import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useRemoveCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/category/delete/${id}`);
      return res.data;
    },
    // Optimistically remove from table before server confirms
    onMutate: async (id) => {
      await queryClient.cancelQueries({ queryKey: ["viewcategory"] });
      const previous = queryClient.getQueryData(["viewcategory"]);

      queryClient.setQueryData(["viewcategory"], (old) => {
        if (!old) return old;

        // Handle all response shapes: [], { data: [] }, { data: { categories: [] } }
        const removeById = (list) =>
          Array.isArray(list)
            ? list.filter((c) => (c._id || c.id) !== id)
            : list;

        if (Array.isArray(old)) return removeById(old);
        if (Array.isArray(old?.data)) return { ...old, data: removeById(old.data) };
        if (Array.isArray(old?.data?.categories))
          return { ...old, data: { ...old.data, categories: removeById(old.data.categories) } };
        return old;
      });

      return { previous };
    },
    // If delete fails, roll back the optimistic update
    onError: (error, _id, context) => {
      if (context?.previous) {
        queryClient.setQueryData(["viewcategory"], context.previous);
      }
      console.error("Delete category failed:", error);
      alert(`Delete failed: ${error?.response?.data?.message || error.message || "Please try again."}`);
    },
    // Always refetch to stay in sync with server
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["viewcategory"] });
    },
  });
};